import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ISessionTemplate } from "../../utils/types/models";

export default createEntityReducer<ISessionTemplate>(Endpoint.SessionTemplates, Endpoint.SessionTemplatesList);
